(function () {
  'use strict';

  function getGender() {
    try {
      return localStorage.getItem('evdnce_gender') ||
             sessionStorage.getItem('evdnce_gender') ||
             document.documentElement.getAttribute('data-evdnce-g') ||
             'men';
    } catch(e) { return 'men'; }
  }

  function applyHoverImages() {
    var gender = getGender();
    document.querySelectorAll('product-card').forEach(function(card) {
      /* Ensure hoverable class */
      var media = card.querySelector('.product-card__media');
      if (media && !media.classList.contains('product-card__media--hoverable')) {
        media.classList.add('product-card__media--hoverable');
      }

      var hoverImg = card.querySelector('.hover-img');
      if (!hoverImg) return;

      /* Use data-hover-{gender} (second gender-tagged image) as the hover src.
         Fall back to opposite gender, then leave the theme default in place. */
      var src = card.getAttribute('data-hover-' + gender);
      if (!src && gender === 'women') src = card.getAttribute('data-hover-men');
      if (!src && gender === 'men')   src = card.getAttribute('data-hover-women');
      if (!src) return; /* No gender hover image — leave theme default */

      hoverImg.src = src;
      hoverImg.removeAttribute('srcset');
      hoverImg.setAttribute('loading', 'eager');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHoverImages);
  } else {
    applyHoverImages();
  }
  setTimeout(applyHoverImages, 500);
  setTimeout(applyHoverImages, 1500);

  /* Re-run after AJAX filter/sort */
  document.addEventListener('DOMContentLoaded', function() {
    var grid = document.getElementById('ProductGridContainer');
    if (grid) {
      new MutationObserver(function() {
        setTimeout(applyHoverImages, 200);
      }).observe(grid, { childList: true, subtree: true });
    }
  });

  window.evdncePLPHoverRefresh = applyHoverImages;

})();
